import script from "./SignInPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInPage.vue?vue&type=style&index=0&id=ff5d7434&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff5d7434"]])

export default __exports__